import {IComponentOptions, IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {MøteevalueringsStatus, MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";

require('./evaluering.scss');

export function registrerEvalueringKomponent(angular: IModule) {
    angular
        .component('wmMoeteEvaluering', evalueringKomponentDef())
}

export function evalueringKomponentDef(): IComponentOptions {
    return {
        bindings: {moete: "<"},
        controller: Evaluering.forInjisering(),
        template: require('./evaluering.html')
    };
}

export class Evaluering implements IController {
    static forInjisering() {
        return [
            MøteRessurs.regNavn,
            Evaluering
        ]
    }

    constructor(private møteRes: MøteRessurs) {
    }

    moete: l.MøteModell; //settes via bindings/$onChanges

    evalueringsstatuser = MøteevalueringsStatus;
    evalueringsstatus: MøteevalueringsStatus;

    vurdering: number = null;

    velgVurdering(vurdering: number) {
        this.vurdering = vurdering;
    }

    registrerVurdering() {
        this.møteRes.registrerVurdering(this.moete.id, this.vurdering).$promise
            .then(møte => {
                this.moete = møte;
                this.beregnEvalueringsinfo();
                this.blankUtVurdering();
            });
    }

    blankUtVurdering() {
        this.vurdering = null;
    }

    $onChanges(changes: IOnChangesObject) {
        if (changesInneholder(changes, 'moete'))
            this.beregnEvalueringsinfo();
    }

    private beregnEvalueringsinfo() {
        this.evalueringsstatus = this.møteRes.møteevalueringsstatus(this.moete);
    }
}

